/**
 * Typ události zobrazovače mapy.
 */
enum ViewerEventType {
    /**
     * Vyvolání akce nad feature.
     */
    ACTION = 'ACTION',

    /**
     * Použití nástroje typu {@link ViewerToolType.NEW_OBJECT}.
     */
    NEW_OBJECT = 'NEW_OBJECT',

    /**
     * Výběr features nástrojem typu {@link ViewerToolType.SELECT_FEATURES}.
     */
    SELECT_FEATURES = 'SELECT_FEATURES',

    /**
     * Interakce uživatele s mapou.
     */
    MAP_INTERACTION = 'MAP_INTERACTION',
}

export default ViewerEventType;
